import {useEffect, useRef, useState} from "react";
import "./scss/Sidebar.scss"
import {useIntl} from "react-intl";
import {NavLink} from "react-router-dom";
import {LocaleSwitcher} from "./LocaleContext";
import { ReactComponent as SurveysIcon } from "./svg/surveys.svg"
import { ReactComponent as ContactsIcon } from "./svg/contacts.svg"
import { ReactComponent as UsersIcon } from "./svg/users.svg"
import { ReactComponent as ToggleSidebar } from "./svg/toggle.svg"
import {ReactComponent as Logo} from "./svg/logo.svg";
import useWindowDimensions from "./DataFunctions";
import {useAuthData, useCurrentUserData} from "./App";

export default function Sidebar() {
    const [sidebarOpen, setSidebarOpen] = useState( localStorage.getItem("sidebarOpen") ? JSON.parse(localStorage.getItem("sidebarOpen")) : true)
    const {width} = useWindowDimensions()
    const [windowTabletOrSmaller, setWindowTabletOrSmaller] = useState(false)
    useEffect(()=>{
        if (!windowTabletOrSmaller && width < 769) {
            setSidebarOpen(false)
            setWindowTabletOrSmaller(true)
        }
        if (windowTabletOrSmaller && width > 768) {
            setSidebarOpen(true)
            setWindowTabletOrSmaller(false)
        }
    },[width])
    const intl = useIntl()
    if (!sidebarOpen) {
        return <div className={"sidebar closed"}>
            <h1>
            {!windowTabletOrSmaller ?
            <div className={"toggle-sidebar"} onClick={() => {
                localStorage.setItem("sidebarOpen", JSON.stringify(!sidebarOpen))
                setSidebarOpen(!sidebarOpen)
            }}>
                <ToggleSidebar />
            </div> :
                <div className={"logo"}>

                </div>
            }
            </h1>
            <nav>
                <ul>
                    <li>
                        <NavLink to={"/surveys"}>
                            <SurveysIcon />
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to={"/contacts"}>
                            <ContactsIcon />
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to={"/users"}>
                            <UsersIcon />
                        </NavLink>
                    </li>
                </ul>
            </nav>
            <Profile collapse={true}/>
        </div>
    }
    return <div className={"sidebar"}>
        <h1>
            <div className={"logo"}>
                <Logo />
            </div>
            <div className={"toggle-sidebar"} onClick={() => {
                localStorage.setItem("sidebarOpen", JSON.stringify(!sidebarOpen))
                setSidebarOpen(!sidebarOpen)
            }}>
                <ToggleSidebar />
            </div>
        </h1>
        <nav>
            <ul>
                <li>
                    <NavLink to={"/surveys"}>
                        <SurveysIcon />
                        {intl.formatMessage(
                        {
                            id: 'main.sidebar.surveys',
                            defaultMessage: 'Surveys',
                        })}
                    </NavLink>
                </li>
                <li>
                    <NavLink to={"/contacts"}>
                        <ContactsIcon />
                        {intl.formatMessage(
                        {
                         id: 'main.sidebar.contacts',
                            defaultMessage: 'Contacts',
                        })}
                    </NavLink>
                </li>
                <li>
                    <NavLink to={"/users"}>
                        <UsersIcon />
                        {intl.formatMessage(
                        {
                            id: 'main.sidebar.users',
                            defaultMessage: 'Users',
                        })}
                    </NavLink>
                </li>
            </ul>
        </nav>
        <Profile />
    </div>
}

function Profile({collapse}) {
    const {currentUserData} = useCurrentUserData()
    const {authData} = useAuthData()
    const firstName = currentUserData && currentUserData?.meta && currentUserData.meta.hasOwnProperty("firstname") ? currentUserData.meta.firstname : null
    const lastName = currentUserData && currentUserData?.meta && currentUserData.meta.hasOwnProperty("lastname") ? currentUserData.meta.lastname : null
    const userid = currentUserData?.meta?.userid ? currentUserData.meta.userid : (currentUserData?.meta?.email ? currentUserData.meta.email : authData.uid)
    const initials = (firstName && lastName) ? firstName.charAt(0) + lastName.charAt(0) : userid.substring(0, 2)
    const [showProfilePopover, setShowProfilePopover] = useState(false)
    const popoverRef = useRef(null)
    const popoverTriggerRef = useRef(null)
    const intl = useIntl()
    const logoutURL = authData.hasOwnProperty("logoutURL") ? authData.logoutURL : null

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside)
        function handleClickOutside(event) {
            if (popoverRef.current && !popoverRef.current.contains(event.target) && !popoverTriggerRef.current.contains(event.target) ) {
                setShowProfilePopover(false)
            }
            return () => {
                document.removeEventListener("mousedown", handleClickOutside);
            }
        }
    },[popoverRef])

    return <div className={collapse ? "profile-container collapse" : "profile-container"}>
        {collapse ?
            <button className={"profile-icon"} ref={popoverTriggerRef} onClick={()=>setShowProfilePopover(!showProfilePopover)}>{initials}</button> :
                <button className={"profile-button-container"} ref={popoverTriggerRef} onClick={()=>setShowProfilePopover(!showProfilePopover)}>
                    <div className={"profile-icon"}>{initials}</div>
                    {intl.formatMessage({
                        id: 'settings',
                        defaultMessage: 'Settings',
                    })}
                </button>
                }
        {showProfilePopover &&
        <div className={"profile-popover"} ref={popoverRef}>
            <>
                <h2>
                    {(firstName && lastName) ?
                        firstName +" "+ lastName :
                        userid
                    }
                </h2>
                <hr/>
            </>

            <h4>
                {intl.formatMessage({
                    id: 'profile',
                    defaultMessage: 'Profile',
                })}
            </h4>
            <p>{userid}</p>
            <hr/>
            <h4>
                {intl.formatMessage({
                    id: 'language',
                    defaultMessage: 'Language',
                })}
            </h4>
            <LocaleSwitcher />
            {logoutURL &&
            <>
                <hr/>
                <a href={logoutURL}>
                    {intl.formatMessage({
                        id: 'logOut',
                        defaultMessage: 'Log out',
                    })}
                </a>
            </>
            }

        </div>
        }
    </div>
}